import { render } from "./NegociosComoFunciona.vue?vue&type=template&id=54d16743&scoped=true"
import script from "./NegociosComoFunciona.vue?vue&type=script&lang=js"
export * from "./NegociosComoFunciona.vue?vue&type=script&lang=js"

import "./NegociosComoFunciona.vue?vue&type=style&index=0&id=54d16743&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d16743"]])

export default __exports__